import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const modules = import.meta.glob('./locales/*.json', { eager: true, import: 'default' }) as Record<string, Record<string, unknown>>;

const resources: Record<string, { translation: Record<string, unknown> }> = {};
Object.entries(modules).forEach(([path, data]) => {
    if (path.includes('/_')) {
        return;
    }
    const code = path.match(/\/([a-z]+)\.json$/)?.[1];
    if (code) {
        resources[code] = { translation: data };
    }
});

void i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
});

export default i18n;

export function intlLocale(code?: string | null) {
    const lang = (code || 'en').toLowerCase().split('-')[0];

    return lang === 'en' ? 'en-IN' : `${lang}-IN`;
}
